export type ServiceName = (typeof SERVICE_NAMES)[keyof typeof SERVICE_NAMES];

export const SERVICE_NAMES = {
  WALDEN_DASHBOARD: 'Dashboard.All',
  WALDEN_VIEW_WAREHOUSING: 'Walden-View.Warehousing',
  WALDEN_VIEW_ORDER_TRACKING: 'Walden-View.Order-Tracking',
  WALDEN_VIEW_TRANSPORT: 'Walden-View.Transport',
  WALDEN_VIEW_OTC: 'Walden-View.Order-2-Cash',
  WALDEN_ML: 'Walden-ML.All',
  WALDEN_ORCHESTRATION: 'Walden-Orchestration.All',
  WALDEN_GREEN_LEVEL0: 'Walden-Green.Level-0',
  WALDEN_GREEN_LEVEL1: 'Walden-Green.Level-1',
  WALDEN_GREEN_LEVEL2: 'Walden-Green.Level-2',
  WALDEN_GREEN_LEVEL3: 'Walden-Green.Level-3',
  WALDEN_CONNECT: 'Walden-Connect.All',
  WALDEN_PULSE: 'Walden-Pulse.All',
  WALDEN_VAS: 'Walden-VAS.All',
  WALDEN_BOX: 'Walden-Box.All',
  WALDEN_TRACE: 'Walden-Trace.All',
  WALDEN_CHAT: 'Walden-Chat.All',
} as const;
